"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEFormatter = void 0;
const AEFormValidator_1 = require("./AEFormValidator");
class AEFormatter {
    static gewicht(options) {
        return AEFormValidator_1.AEFormValidator.gewicht(options);
    }
    static laenge(options) {
        return AEFormValidator_1.AEFormValidator.laenge(options);
    }
    static count(options) {
        return AEFormValidator_1.AEFormValidator.count(options);
    }
}
exports.AEFormatter = AEFormatter;
//# sourceMappingURL=AEFormatter.js.map